module.exports = __webpack_public_path__ + "img/4.96a6801.jpg";